import { Component, Input, OnInit } from '@angular/core';

/**
 * Generated class for the NumberPagerComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'number-pager',
  templateUrl: 'number-pager.html',
})
export class NumberPagerComponent implements OnInit {
  @Input() pageIndex: number;
  @Input() maxIndex: number;

  pages;

  constructor() {
    console.log('Hello NumberPagerComponent Component');
  }

  ngOnInit(): void {
    this.pages = new Array(this.maxIndex);
  }
}



// WEBPACK FOOTER //
// ./src/components/number-pager/number-pager.ts